"use client";

import { useTranslation } from "react-i18next";
import Image from "next/image";
import Link from "next/link";
import { Button as ButtonLib } from "@npm_leadtech/qr-ui-components";

import { paths } from "@/utils/paths";

import { ErrorFallbackProps } from "./types";
import { PAGES } from "@/data/types/pages";

export const ErrorFallback = ({ onReset: _onReset, navigateTo, style }: ErrorFallbackProps) => {
  const { t } = useTranslation(PAGES.ERROR);

  const handleGoToHome = () => {
    window.location.href = navigateTo ?? paths.home();
  };

  return (
    <div
      data-testid="error-fallback"
      className="error-fallback"
      style={style}
    >
      <div className="error-fallback__container">
        <Image
          src={"/images/error.png"}
          alt={t("image_alt")}
          width={96}
          height={96}
          className="error-fallback__image"
          data-testid="error-fallback-image"
          priority
        />
        <div className="error-fallback__content">
          <div className="error-fallback__text-container">
            <h1
              className="error-fallback__title"
              data-testid="error-fallback-title"
            >
              {t("title")}
            </h1>
            <p
              className="error-fallback__description"
              data-testid="error-fallback-description"
            >
              {t("description")}
            </p>
          </div>
          <div className="error-fallback__button-container">
            <ButtonLib
              onClick={handleGoToHome}
              variant="secondary"
              label={t("go_to_home_button")}
              ariaLabel={t("go_to_home_button")}
              dataQA="error-go-home"
              type="button"
            />
          </div>
        </div>
        <p className="error-fallback__support-text">
          {t("support_text")}{" "}
          <Link
            href={paths.contactUs()}
            className="error-fallback__support-link"
            data-testid="error-fallback-support-link"
          >
            {t("support_link_text")}
          </Link>
        </p>
      </div>
    </div>
  );
};
